var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.videoRoomEngine === 'jitsi')?_c('Jitsi',{attrs:{"patientId":_vm.patientId,"appointmentId":_vm.appointmentId,"autoJoin":_vm.autoJoin}}):_vm._e(),(_vm.videoRoomEngine === 'twilio')?_c('Twilio',{attrs:{"patientId":_vm.patientId,"appointmentId":_vm.appointmentId,"autoJoin":_vm.autoJoin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }